import { render } from "./ServicePackagesSidebar.vue?vue&type=template&id=78c203f6&scoped=true"
import script from "./ServicePackagesSidebar.vue?vue&type=script&lang=js"
export * from "./ServicePackagesSidebar.vue?vue&type=script&lang=js"

import "./ServicePackagesSidebar.vue?vue&type=style&index=0&id=78c203f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78c203f6"]])

export default __exports__